// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import styled from 'styled-components';

export const DefaultRadioContainer = styled.div`
    display: flex;
    margin-top:1.25rem;
    flex-flow: row no-wrap;
    justify-content:space-between;

    .shell-button-group{
    width:100%;
    border:1px solid rgba(255,255,255,0.1);
    }
    .shell-button-group label{
    padding:15px;
    border-radius:2px;
    flex:1;
    }
    label:has(input[type=radio]:checked){
    background-color:rgba(251,207,9,1);
    color:black;
    }
`